import { Component } from '@angular/core';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-it-event-management',
  imports: [FeatureHero],
  templateUrl: './it-event-management.html',
  styleUrl: './it-event-management.scss',
})
export class ItEventManagement {

}
